import React from 'react';

import Form from 'Components/Form';
import FormNote from 'Components/FormNote';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';

class ForgotPasswordForm extends React.PureComponent {
  render() {
    const formNote = (
      <FormNote
        title={
          <ConnectedFormattedMessage id="form.note.forgotPassword.title" />
        }
        text={<ConnectedFormattedMessage id="form.note.forgotPassword.text" />}
      />
    );
    return (
      <Form
        type="forgotPassword"
        id="forgotPassword"
        formStyle="login"
        formNote={formNote}
        messagePosition="page-top"
        submitButtonType="primary"
      />
    );
  }
}

export default ForgotPasswordForm;
